import React, { Component } from "react";
import classnames from "classnames";

import { IconButton, IIconButtonProps } from "../common/IconButton";
import * as styles from "./ActionButton.scss";

export type IActionButtonProps = IIconButtonProps;

export class ActionButton extends Component<IActionButtonProps> {
    public render() {
        const { className, ...props } = this.props;

        return (
            <IconButton
                {...props}
                className={classnames(
                    styles["action-button"],
                    className,
                    styles.button,
                )}
            />
        );
    }
}
